import { render, staticRenderFns } from "./factory_detail.vue?vue&type=template&id=4b8086f6&scoped=true"
import script from "./factory_detail.vue?vue&type=script&lang=js"
export * from "./factory_detail.vue?vue&type=script&lang=js"
import style0 from "./factory_detail.vue?vue&type=style&index=0&id=4b8086f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8086f6",
  null
  
)

export default component.exports